import { render } from "./Order.vue?vue&type=template&id=07514e52&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=07514e52&lang=scss"
import "./Order.vue?vue&type=style&index=1&id=07514e52&scoped=true&lang=scss"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07514e52"]])

export default __exports__